<template>
  <el-container>
    <el-header>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>资源中心</el-breadcrumb-item>
        <el-breadcrumb-item>费率管理</el-breadcrumb-item>
      </el-breadcrumb>
    </el-header>
    <el-main>
      <el-row>
        <el-col :span="24">
          <el-tabs v-model="activeName" type="border-card">

            <!--列表数据-->
            <el-tab-pane label="执行费率列表" name="rateList" v-if="checkPermission(['bee:res:rate:getRates'])">
              <el-row v-show="showFilters">
                <search
                  :searchForm="searchForm"
                  :operatorForSelect="operatorForSelect"
                  :searchLoading="searchLoading"
                  @submitSearchForm="submitSearchForm"
                  ref="searchForm"
                ></search>
                <el-form>
                  <el-col :span="2.5" class="diy-class" >
                    <el-form-item>
                      <el-button size="mini" type="primary" @click="rateAdd('Q')" icon="el-icon-plus" class="el-btn"
                                 v-if="checkPermission(['bee:res:rate:saveRate'])">
                        新增费率
                      </el-button>
<!--                      <el-button size="mini" type="primary" @click="rateAdd('D')" icon="el-icon-plus" class="el-btn"
                                 v-if="checkPermission(['bee:res:rate:saveRate'])">
                        登记电单车桩费率
                      </el-button>-->
                    </el-form-item>
                  </el-col>
                </el-form>
              </el-row>
              <!--      列表组件        -->
              <list
              :rateDataTable="rateDataTable"
              :listLoading="listLoading"
              @rateEdit="rateEdit"
              @rateDelete="rateDelete"
              ></list>
              <!-- 分页组件 -->
              <Pagination v-bind:child-msg="pageparam" @callFather="changePage"></Pagination>
            </el-tab-pane>

            <!--历史费率列表-->
            <el-tab-pane label="历史费率列表" name="hisRate" v-if="checkPermission(['bee:res:rate:getHisRates'])">

              <hislist v-if="activeName=='hisRate'" :operatorHisList="operatorHisList"></hislist>

            </el-tab-pane>


            <el-tab-pane label="占桩费率列表" name="PileOccupationFee" v-if="checkPermission(['bee:res:rate:takeUpPile:page'])">

              <PileOccupationFee v-if="activeName == 'PileOccupationFee'" :operatorHisList="operatorHisList"></PileOccupationFee>
            </el-tab-pane>
            <el-tab-pane label="占桩费率记录列表" name="ccupyPileArchiving" v-if="checkPermission(['bee:res:rate:takeUpPileRecord:page'])">

              <ccupyPileArchiving v-if="activeName == 'ccupyPileArchiving'" :operatorHisList="operatorHisList"></ccupyPileArchiving>
            </el-tab-pane>


            <!--使用中费率-->
<!--            <el-tab-pane label="使用中的费率" name="nowRate" v-if="checkPermission(['bee:res:rate:getHisRates'])">

              <nowlist v-if="activeName=='nowRate'" :operatorHisList="operatorHisList"></nowlist>

            </el-tab-pane>-->

          </el-tabs>
        </el-col>
      </el-row>
      <!-- 编辑组件 -->
      <add
      :editForm="editForm"
      :timeForm="timeForm"
      :editFormVisible="editFormVisible"
      :operatorForSelect="operatorForSelect"
      :standardAble="standardAble"
      :editSubmitLoading="editSubmitLoading"
      :tableData="tableData"
      :timesAble="timesAble"
      :topCheckFlag="topCheckFlag"
      :summitCheckFlag="summitCheckFlag"
      :flatCheckFlag="flatCheckFlag"
      :valleyCheckFlag="valleyCheckFlag"
      :YesNoEnumData="YesNoEnumData"
      :pileType="pileType"
      :kindList="kindList"
      :timeSlotList="timeSlotList"
      :timeSlotId="timeSlotId"
      @closeEditForm="closeEditForm"
      @editSubmit="editSubmit"
      @timeMouseenter="timeMouseenter"
      @timeMousedown="timeMousedown"
      @topCheck="topCheck"
      @summitCheck="summitCheck"
      @flatCheck="flatCheck"
      @valleyCheck="valleyCheck"
      @standardInputChange="standardInputChange"
      @timesInputChange="timesInputChange"
      ref="add"
      ></add>
    </el-main>
  </el-container>
</template>

<script>
  import Pagination from '../../../components/Pagination'
  import rateApi from '../../resourceCenter/api/rateApi'
  import commonApi from '../../resourceCenter/api/commonApi'
  import {verifyDiscountRate} from '../../../common/validator'
  import search from "./rateManager/search"
  import list from "./rateManager/list"
  import add from "./rateManager/add"
  import hislist from "./rateManager/hislist"
  import nowlist from "./rateManager/nowList"
  import PileOccupationFee from "./rateManager/pileOccupation/PileOccupationFee.vue";
  import ccupyPileArchiving from "./rateManager/pileOccupation/ccupyPileArchiving.vue";

  export default {
    name: 'rateManager',
    data() {
      return {
        operatorForSelect: [],
        operatorHisList: [],
        rolClassName: 'timeLabInCol el-col el-col-6',
        topCheckFlag: true, // 尖时被选中
        summitCheckFlag: true, // 峰被选中
        flatCheckFlag: true, // 平被选中
        valleyCheckFlag: true, // 谷被选中
        checkFlag: '', // 当前应该赋值的className
        timesAble: true,
        standardAble: true,
        activeName: 'rateList',
        showFilters: true,
        listLoading: false,
        rateDataTable: [{}],
        // 多选集合
        pileDataSelection: [],
        YesNoEnumData:[
          {value: 'Y', message: '是'},
          {value: 'N', message: '否'}
        ],
        // 查询
        searchLoading: false,
        searchFormVisible: false,
        searchForm: {// 未初始化不传递参数，影响后台接查询
        },
        // 编辑
        editFormVisible: false,
        editSubmitLoading: false,
        editForm: {
          timeList: null,
          type:"",
          pileType:"Q"
        },
        timeForm: {},
        // 详情
        detailFormVisible: false,
        detailForm: {},
        // 分页参数
        pageparam: {
          t: {},
          currentPage: 1,
          pageSize: 10,
          total: 0
        },
        tableData: [
          {
            date1: '0:00-0:30',
            date2: '0:30-1:00',
            date3: '1:00-1:30',
            date4: '1:30-2:00'
          },
          {
            date1: '2:00-2:30',
            date2: '2:30-3:00',
            date3: '3:00-3:30',
            date4: '3:30-4:00'
          },
          {
            date1: '4:00-4:30',
            date2: '4:30-5:00',
            date3: '5:00-5:30',
            date4: '5:30-6:00'
          },
          {
            date1: '6:00-6:30',
            date2: '6:30-7:00',
            date3: '7:00-7:30',
            date4: '7:30-8:00'
          },
          {
            date1: '8:00-8:30',
            date2: '8:30-9:00',
            date3: '9:00-9:30',
            date4: '9:30-10:00'
          },
          {
            date1: '10:00-10:30',
            date2: '10:30-11:00',
            date3: '11:00-11:30',
            date4: '11:30-12:00'
          },
          {
            date1: '12:00-12:30',
            date2: '12:30-13:00',
            date3: '13:00-13:30',
            date4: '13:30-14:00'
          },
          {
            date1: '14:00-14:30',
            date2: '14:30-15:00',
            date3: '15:00-15:30',
            date4: '15:30-16:00'
          },
          {
            date1: '16:00-16:30',
            date2: '16:30-17:00',
            date3: '17:00-17:30',
            date4: '17:30-18:00'
          },
          {
            date1: '18:00-18:30',
            date2: '18:30-19:00',
            date3: '19:00-19:30',
            date4: '19:30-20:00'
          },
          {
            date1: '20:00-20:30',
            date2: '20:30-21:00',
            date3: '21:00-21:30',
            date4: '21:30-22:00'
          },
          {
            date1: '22:00-22:30',
            date2: '22:30-23:00',
            date3: '23:00-23:30',
            date4: '23:30-24:00'
          }
        ],
        pileType:'Q',
        stationId:'',
        kindList:[],
        timeSlotList:[],
        timeSlotId:''
      }
    },
    methods: {
      standardInputChange() {
        this.timesAble = true
        this.standardAble = false
        let temp = this.returnTemp
        temp.topElectricityFees = ''
        temp.summitElectricityFees = ''
        temp.flatElectricityFees = ''
        temp.valleyElectricityFees = ''
        temp.topServiceFees = ''
        temp.summitServiceFees = ''
        temp.flatServiceFees = ''
        temp.valleyServiceFees = ''
        console.log("editForm.type:" + this.editForm.type)
        this.editForm = temp
        this.topCheckFlag = true
        this.summitCheckFlag = true
        this.flatCheckFlag = true
        this.valleyCheckFlag = true
        this.$nextTick(() => {
          for (let i = 0; i < this.$refs.add.$refs.timeLabInCol.length; i++) {
            this.$refs.add.$refs.timeLabInCol[i].$el.className = this.rolClassName
          }
        })
      },
      timesInputChange() {
        this.standardAble = true
        this.timesAble = false
        let temp = this.returnTemp
        this.editForm = temp
        temp.standardElectricityFees = ''
        temp.standardServiceFees = ''
        console.log("editForm.type:" + this.editForm.type)
        this.editForm = temp
        this.topCheckFlag = false
        this.summitCheckFlag = false
        this.flatCheckFlag = false
        this.valleyCheckFlag = false
      },
      topCheck() {
        this.checkFlag = 'topCheck'
        this.summitCheckFlag = !this.summitCheckFlag
        this.flatCheckFlag = !this.flatCheckFlag
        this.valleyCheckFlag = !this.valleyCheckFlag
      },
      summitCheck() {
        this.checkFlag = 'summitCheck'
        this.topCheckFlag = !this.topCheckFlag
        this.flatCheckFlag = !this.flatCheckFlag
        this.valleyCheckFlag = !this.valleyCheckFlag
      },
      flatCheck() {
        this.checkFlag = 'flatCheck'
        this.topCheckFlag = !this.topCheckFlag
        this.summitCheckFlag = !this.summitCheckFlag
        this.valleyCheckFlag = !this.valleyCheckFlag
      },
      valleyCheck() {
        this.checkFlag = 'valleyCheck'
        this.topCheckFlag = !this.topCheckFlag
        this.summitCheckFlag = !this.summitCheckFlag
        this.flatCheckFlag = !this.flatCheckFlag
      },
      timeClick(event) {
        if (this.topCheckFlag && this.summitCheckFlag && this.flatCheckFlag && this.valleyCheckFlag) {
          this.$message.error('先选择时段标志，再点击时段设置！')
        } else {
          if (event.currentTarget.classList.contains(this.checkFlag)) { // 如果已经绑定过当前css 则移除
            event.currentTarget.classList.remove(this.checkFlag)
          } else {
            if (event.currentTarget.classList.length > 3) { // 如果已经绑定过css 则初始化后再绑定
              event.currentTarget.className = this.rolClassName + ' ' + this.checkFlag
            } else {
              event.currentTarget.classList.add(this.checkFlag)
            }
          }
        }
      },
      timeMouseenter(event) {
        if (event.which === 1) {
          this.timeClick(event)
        }
      },
      timeMousedown(event) {
        this.timeClick(event)
      },
      resetSearchForm() {
        this.searchForm = {}
      },
      submitSearchForm() {
        this.$refs.searchForm.$children[0].validate((valid) => {
          if (!valid) {
            return;
          }
          this.searchLoading = true
          this.listLoading = true
          // let param = Object.assign({}, this.stationSearchForm)
          // para.date = (!para.date || para.date == '') ? '' : util.formatDate.format(new Date(para.date), 'yyyy-MM-dd');
          //查询非备份数据
          this.searchForm.recordType = 1
          this.pageparam.t = this.searchForm
          let param = Object.assign({}, this.pageparam)
          rateApi.getRates(param).then((res) => {
            if (res.code === 0) {
              //console.info("res.data.records"+JSON.stringify(res.data.records))
              this.pageparam.total = res.data.total
              this.rateDataTable = res.data.records
              // this.$message({
              //   message: res.message,
              //   type: 'success'
              // })
            } else {
              // this.$message.error(res.message)
            }
            this.searchLoading = false
            this.listLoading = false
          })
        })
      },
      rateAdd(pileType) {
        this.pileType = pileType
        console.info("this.pileType:"+this.pileType)
        this.editFormVisible = true
        this.timesAble = true
        this.standardAble = true
        this.editForm.type = ''
        this.kindList = [{
          name:'尖',
          electric:'',
          serve:'',
          id:'0',
          allName:''
        },{
          name:'峰',
          electric:'',
          serve:'',
          id:'1',
          allName:''
        },{
          name:'平',
          electric:'',
          serve:'',
          id:'2',
          allName:''
        },{
          name:'谷',
          electric:'',
          serve:'',
          id:'3',
          allName:''
        }]
        this.timeSlotList = []
        this.timeSlotId = ''
        this.editForm = Object.assign({discountRate: 0,electricLossRate: 0,standardElectricityFees: 0,pileType: pileType})
        this.timeForm = Object.assign({})
        /*this.$nextTick(() => {
          for (let i = 0; i < this.$refs.add.$refs.timeLabInCol.length; i++) {
            this.$refs.add.$refs.timeLabInCol[i].$el.className = this.rolClassName
          }
        })*/
      },
      rateDetail(index, row) {
        this.detailFormVisible = true
        this.detailForm = Object.assign({}, row)
      },
      rateEdit(index, row) {
        let A= 'operatorId='+ this.searchForm.operatorId + '&rulesId=' + row.id
        rateApi.getfindByOperatorIdAndRulesId(A).then((res) => {
          let list = []
          list.push({
            name:'尖',
            electric:res.data.topElectricityFees,
            serve:res.data.topServiceFees,
            serveVip:res.data.vipTopServiceFees,
            id:'0',
            allName:'尖:电费'+ res.data.topElectricityFees + ',原价服务费:' + res.data.topServiceFees + ',会员服务费:' + res.data.vipTopServiceFees
          },{
            name:'峰',
            electric:res.data.summitElectricityFees,
            serve:res.data.summitServiceFees,
            serveVip:res.data.vipSummitServiceFees,
            id:'1',
            allName:'峰:电费'+ res.data.summitElectricityFees + ',原价服务费:' + res.data.summitServiceFees + ',会员服务费:' + res.data.vipSummitServiceFees
          },{
            name:'平',
            electric:res.data.flatElectricityFees,
            serve:res.data.flatServiceFees,
            serveVip:res.data.vipFlatServiceFees,
            id:'2',
            allName:'平:电费'+ res.data.flatElectricityFees + ',原价服务费:' + res.data.flatServiceFees + ',会员服务费:' + res.data.vipFlatServiceFees
          },{
            name:'谷',
            electric:res.data.valleyElectricityFees,
            serve:res.data.valleyServiceFees,
            serveVip:res.data.vipValleyServiceFees,
            id:'3',
            allName:'谷:电费'+ res.data.valleyElectricityFees + ',原价服务费:' + res.data.valleyServiceFees + ',会员服务费:' + res.data.vipValleyServiceFees
          })
          this.kindList = list
          this.timeSlotList = res.data.timeSlotList
          this.timeSlotId = res.data.timeSlotId
        })
        this.pileType = row.pileType
        this.editFormVisible = true
        this.editForm = Object.assign({}, row);
        this.editForm.type = this.editForm.typeCode;
        this.editForm.showElectricLossRate = this.editForm.showElectricLossRateCode;
        let param = {serviceBillingRulesId: row.id};
        if (row.typeCode == 'standard') {
          // this.editForm.type = 'standard'
          this.timesAble = true
          this.standardAble = false
          this.standardInputChange()
        } else if (row.typeCode == 'times') {
          // this.editForm.type = 'times'
          this.timesAble = false
          this.standardAble = true
          this.timesInputChange()
          /*rateApi.getTimeSharing(param).then((res) => {
            if (res.code === 0) {
                this.$nextTick(() => {
                for (let i = 0; i < this.$refs.add.$refs.timeLabInCol.length; i++) {
                  this.$refs.add.$refs.timeLabInCol[i].$el.classList.remove('topCheck')
                  this.$refs.add.$refs.timeLabInCol[i].$el.classList.remove('summitCheck')
                  this.$refs.add.$refs.timeLabInCol[i].$el.classList.remove('flatCheck')
                  this.$refs.add.$refs.timeLabInCol[i].$el.classList.remove('valleyCheck')
                  switch (res.data[0]['time' + i]) {
                    case '0' :
                      this.$refs.add.$refs.timeLabInCol[i].$el.classList.add('topCheck')
                      break
                    case '1' :
                      this.$refs.add.$refs.timeLabInCol[i].$el.classList.add('summitCheck')
                      break
                    case '2' :
                      this.$refs.add.$refs.timeLabInCol[i].$el.classList.add('flatCheck')
                      break
                    case '3' :
                      this.$refs.add.$refs.timeLabInCol[i].$el.classList.add('valleyCheck')
                      break
                    default :
                      console.log(this.$refs.add.$refs.timeLabInCol[i].$el.classList)
                      break
                  }
                }
              })
            }
          })*/
        }
      },
      closeEditForm(){
        this.editFormVisible=false
      },
      rateDelete(index, row) {
        this.$confirm('确定要删除：' + row.ruleName + '吗?', '信息', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            rateApi.deleteRate(row.id).then((res) => {
              if (res.code === 0) {
                this.$message({
                  message: res.message,
                  type: 'success'
                })
                this.submitSearchForm()
              } else {
                this.$message.error(res.message)
              }
            })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除！'
            })
          })
      },
      editSubmit(editForm) {
        this.editFormVisible = false
        this.submitSearchForm()
        return
        editForm.validate((valid) => {
            if (!valid) {
              return;
            } else {
              console.log(this.editForm.type)
              if (typeof(this.editForm.type) =="undefined"){
                this.$message.error("请先设置费率")
                return;
              }
              this.$confirm('确认提交吗？', '提示', {}).then(() => {
                this.editSubmitLoading = true
                for (let i = 0; i < this.$refs.add.$refs.timeLabInCol.length; i++) {
                  let classList = this.$refs.add.$refs.timeLabInCol[i].$el.classList
                  switch (classList[classList.length - 1]) {
                    case 'topCheck' :
                      this.timeForm['time' + i] = '0'
                      break
                    case 'summitCheck' :
                      this.timeForm['time' + i] = '1'
                      break
                    case 'flatCheck' :
                      this.timeForm['time' + i] = '2'
                      break
                    case 'valleyCheck' :
                      this.timeForm['time' + i] = '3'
                      break
                    default :
                      this.timeForm['time' + i] = '2'
                      break
                  }
                }
                this.editForm.timeList = this.timeForm
                let param = Object.assign({}, this.editForm)
                // let param = JSON.stringify(this.editForm)

                //新增、编辑调用两个不同的接口
                if(this.editForm.id == null || this.editForm.id ==''){
                  rateApi.saveRate(param).then(res => {
                    this.editSubmitLoading = false
                    if (res.code === 0){
                      this.$message({
                        message: res.message,
                        type: 'success'
                      })
                      this.editFormVisible = false
                      this.submitSearchForm()
                    } else {
                      this.$message.error(res.message)
                      this.editFormVisible = false
                    }
                  })
                }else{
                  //编辑操作
                  rateApi.editRate(param).then(res => {
                    this.editSubmitLoading = false
                    if (res.code === 0){
                      this.$message({
                        message: res.message,
                        type: 'success'
                      })
                      this.editFormVisible = false
                      this.submitSearchForm()
                    } else {
                      this.$message.error(res.message)
                    }
                  })
                }

                /*rateApi.saveOrUpdateRate(param).then((res) => {
                  this.editSubmitLoading = false
                  if (res.code === 0) {
                    this.$message({
                      message: res.message,
                      type: 'success'
                    })
                    this.editFormVisible = false
                    this.submitSearchForm()
                  } else {
                    this.$message.error(res.message)
                  }
                })*/

              })
            }
        })
      },
      clearEditForm(){
        this.$refs.editForm.clearValidate()
      },
      changePage() {
        this.submitSearchForm()
      },
      formatElectricityFees: function (row, column) {
        if (row.standardElectricityFees) {
          return '常规 : ' + row.standardElectricityFees + ' 元/kW·h'
        } else {
          return '尖 : ' + row.topElectricityFees + ' 元/kW·h' +
            '峰 : ' + row.summitElectricityFees + ' 元/kW·h' +
            '平 : ' + row.flatElectricityFees + ' 元/kW·h' +
            '谷 : ' + row.valleyElectricityFees + ' 元/kW·h'
        }
      },
      formatServiceFees: function (row, column) {
        if (row.standardElectricityFees) {
          return '常规 : ' + row.standardServiceFees + ' 元/kW·h'
        } else {
          return '尖 : ' + row.topServiceFees + ' 元/kW·h' +
            '峰 : ' + row.summitServiceFees + ' 元/kW·h' +
            '平 : ' + row.flatServiceFees + ' 元/kW·h' +
            '谷 : ' + row.valleyServiceFees + ' 元/kW·h'
        }
      },
      // 加载下拉框
      loadSelectItem() {
        // 运营商下拉框
        let operatorIds = this.$store.getters.operatorIds;
        console.log(operatorIds.length)
        if(operatorIds.length==1){
          const param= {
            "id": operatorIds[0]
          }
          commonApi.getOperatorsTree(param).then((res) => {
            if (res.code === 0) {
              this.operatorForSelect = res.data
              this.operatorHisList = res.data
            }
          })
        }else{
          commonApi.getOperatorsTree().then((res) => {
            if (res.code === 0) {
              this.operatorForSelect = res.data
              this.operatorHisList = res.data

            }
          })
        }
      }
    },
    components: {
      Pagination,
      search,
      list,
      add,
      hislist,
      nowlist,
      PileOccupationFee,
      ccupyPileArchiving
    },
    mounted() {
      this.submitSearchForm()
    },
    created: function () {
      this.loadSelectItem()
      // this.stationCode= sessionStorage.getItem('stationCode');
    },
    computed: {
      returnTemp() {
        let temp = Object.assign({}, this.editForm)
        return temp
      },
      getStationCode(){
        this.stationId= this.$store.state.stationCode

      }
    },

  }
</script>

<style scoped lang="less">
  .el_search {
    background-color: teal;
    color: white;
  }

  .el_clear {
    background-color: darkorange;
    color: white;
  }

  .el-btn {
    /*float: right;*/
    margin-bottom: 15px;
  }
  /deep/ .diy-class {
    .el-form-item__content {
      line-height: 0px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/rateManager.vue